import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import { get } from 'lodash';

import { SUPPORTED_LOCALES } from 'constants/locales';
import FaqItemModel from 'models/FaqItem';
import ACTIONS from 'state/constants';

const setStructuredDataScript = data => {
  const jsonLdScript = document.querySelector('script[type="application/ld+json"]');

  const jsonld = jsonLdScript?.textContent.length > 1 ? JSON.parse(jsonLdScript.textContent) : {};
  const newData = { ...jsonld, ...data };
  const newJson = JSON.stringify(newData);

  jsonLdScript.innerHTML = newJson;
};

export const insertAdditionalStructuredData = data => {
  const jsonLdScript = document.querySelector('script[type="application/ld+json"]');

  const newData = { ...data };
  const newJson = JSON.stringify(newData);

  const newScript = document.createElement('script');
  newScript.type = 'application/ld+json';
  newScript.innerHTML = newJson;

  jsonLdScript?.insertAdjacentElement('afterend', newScript);
};

const setSchemaMarkup = () => next => action => {
  /* 
    This middleware adds async review values to our schema
  */
  next(action);

  /* 
    This middleware adds structured data to our collection page schema
  */
  if (action.type === ACTIONS.SET_COLLECTION_STRUCTURED_DATA) {
    const faqItems = get(action, ['payload', 'faqItems', SUPPORTED_LOCALES.EN_US]) ?? [];
    const description = get(action, ['payload', 'description']) ?? {};
    const name = get(action, ['payload', 'name']) ?? '';
    // Remove h2 tags from description
    const descriptionOptions = {
      renderNode: {
        [BLOCKS.HEADING_2]: () => '',
      },
    };
    const descriptionText = documentToHtmlString(description, descriptionOptions);

    if (descriptionText) {
      const structuredData = {
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        '@id': `${name} Collection Page`,
        name,
        description: descriptionText,
      };

      insertAdditionalStructuredData(structuredData);
    }

    if (faqItems.length) {
      const parsedItems = faqItems?.map(itemData => {
        const fields = get(itemData, 'fields', {});
        const { question, answer } = new FaqItemModel(fields);

        return {
          question,
          answer,
        };
      });

      const structuredData = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        '@id': `${name} FAQ`,
        name: `${name} FAQ`,
        mainEntity: parsedItems.map(faqItem => {
          return {
            '@type': 'Question',
            name: faqItem.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: documentToHtmlString(faqItem.answer),
            },
          };
        }),
      };

      setStructuredDataScript(structuredData);
    }
  }
};

export default setSchemaMarkup;
